export default "__VITE_ASSET__BAt6bXYb__"